import * as actions from "./PageHeaderType";

const INITIAL_STATE = {
    pageHeading: "",
};

const pageHeaderReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actions.SETPAGEHEADING:
            return {
                ...state,
                pageHeading: action.payload,
            };
        default:
            return state;
    };
};

export default pageHeaderReducer;